/**
 * 暂停
 */
const PauseIcon = ({ width = 96, height = 96 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        width="96"
        height="96"
        rx="48"
        transform="matrix(1 0 0 -1 0 96.001)"
        fill="black"
        fillOpacity="0.4"
      />
      <rect x="32" y="32.001" width="8" height="32" fill="white" />
      <rect x="56" y="32.001" width="8" height="32" fill="white" />
    </svg>
  )
}

export default PauseIcon
